import { Fragment, useLayoutEffect } from 'react';
import {
  FlowBuilder2Watcher,
  FlowBuilder2ContextProvider,
  useEditorStore,
  useFlowBuilder2Store,
  useAssistantLoadingStore,
} from '@diana/core';
import { useFlowBuilder2PageStore } from './Store/useFlowBuilder2PageStore';
import { FlowBuilder2PageContextProvider } from './Context/FlowBuilder2PageContextProvider';
import { useFlowBuilder2PageContext } from './Context/useFlowBuilder2PageContext';
import { BuilderView } from './Views/BuilderView/BuilderView';
import { PreviewView } from './Views/PreviewView/PreviewView';
import { FlowBuilder2PageModal } from './Modal/FlowBuilder2PageModal';
import { FlowBuilder2PageViewNameEnum } from './Context/FlowBuilder2PageContext.types';
import { FlowBuilderModalContentTypeEnum } from './Store/FlowBuilder2PageStore.types';
import { GlobalStyles, useTheme } from '@mui/material';

export const FlowBuilder2Page = () => {
  const { palette } = useTheme();

  const setFlow = useEditorStore((s) => s.setFlow);
  const resetEditor = useEditorStore((s) => s.reset);
  const resetBuilder = useFlowBuilder2Store((s) => s.reset);
  const resetBuilderPage = useFlowBuilder2PageStore((s) => s.reset);
  const resetEditPending = useFlowBuilder2PageStore((s) => s.resetEditPending);
  const resetChatLoadingStore = useAssistantLoadingStore((s) => s.reset);

  useLayoutEffect(() => {
    return () => {
      setFlow(null);
      resetEditor();
      resetBuilder();
      resetBuilderPage();
      resetEditPending();
      resetChatLoadingStore();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FlowBuilder2ContextProvider>
      <FlowBuilder2PageContextProvider>
        <GlobalStyles styles={{ body: { backgroundColor: palette.background.paper } }} />
        <ActiveView />
        <FlowBuilder2PageModal />
      </FlowBuilder2PageContextProvider>
      <BuilderWatcher />
    </FlowBuilder2ContextProvider>
  );
};

const BuilderWatcher = () => {
  const canWatch = useFlowBuilder2PageStore((s) => {
    if (s.activeModal?.name === FlowBuilderModalContentTypeEnum.AdvancedEditor) return false;
    return !s.layoutDndDragItem;
  });
  return canWatch ? <FlowBuilder2Watcher /> : <Fragment />;
};

const ActiveView = () => {
  const { activeView } = useFlowBuilder2PageContext();
  return activeView === FlowBuilder2PageViewNameEnum.Preview ? <PreviewView /> : <BuilderView />;
};
